<template>
  <div v-if="user && user.value"
       class="d-flex align-center user-button-wrapper">
    <v-menu
      v-model="showMenu"
      offset-y
      nudge-bottom="5"
      :close-on-content-click="false"
      min-width="280"
      left
      content-class="user-menu-content"
    >
      <template v-slot:activator="{ on }">
        <v-hover v-slot:default="{ hover }">
          <v-sheet
            v-on="on"
            color="transparent" 
            class="user-avatar-wrapper">
              <v-avatar
                v-if="user && user.value"
                :size="$vuetify.breakpoint.smAndDown ? 48 : 44"
                :class="{'avatar-hover': hover}"
                class="user-avatar mt-1"
              >
                <span class="text-uppercase" style="font-size: 1.2rem;">{{ user.value.user_name.substring(0, 1) }}</span>
              </v-avatar>
          </v-sheet>
        </v-hover>
      </template>

      <v-card class="user-menu-card" flat>
        <div class="d-flex justify-space-between align-center py-3 px-5">
          <span class="subtitle-1 font-weight-medium">Cuenta</span>
          <v-btn icon small @click="showMenu = false">
            <v-icon size="20">{{ mdiClose }}</v-icon>
          </v-btn>
        </div>

        <v-divider></v-divider>

        <div class="d-flex align-center px-5 py-4">
          <v-avatar
            v-if="user && user.value"
            :size="$vuetify.breakpoint.smAndDown ? 48 : 48"
            class="user-avatar mr-3"
          >
          <span class="text-uppercase" style="font-size: 1.2rem;">{{ user.value.user_name.substring(0, 1) }}</span>
        </v-avatar>

          <div class="d-flex flex-column">
            <span class="subtitle-2 font-weight-medium">{{ user.value.user_name }}</span>
            <span class="caption text--secondary">{{ user.value.user_email }}</span>
          </div>
        </div>

        <v-divider></v-divider>

        <v-list class="user-menu-list py-2">
          <router-link
            v-if="false && $root.currentUser && $root.currentUser.isAdmin()"
            to="/admin"
            class="text-decoration-none">
            <v-list-item class="menu-item">
              <v-list-item-icon class="mr-3">
                <v-icon color="amber">mdi-shield-crown</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="amber--text">Administrador</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link 
            v-if="false"
            to="/perfil"
            class="text-decoration-none">
            <v-list-item class="menu-item">
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Mi Perfil</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link 
            v-if="false"
            to="/perfil/configuracio"
            class="text-decoration-none">
            <v-list-item class="menu-item">
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-cog</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Configuración</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <!-- <v-divider class="my-2"></v-divider> -->

          <v-list-item
            @click="signOut"
            class="menu-item">
            <v-list-item-icon class="mr-3">
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Cerrar Sesión</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import {mdiClose} from '/src/assets/mdi.json'

export default {
  data() {
    return {
      mdiClose: mdiClose,
      showMenu: false
    }
  },
  computed: {
    token() {
      return this.$root.token
    },
    user() {
      return this.$root.currentUser
    },
    isMobile: function () {
      return this.$vuetify.breakpoint.name === 'sm' || this.$vuetify.breakpoint.name === 'xs'
    }
  },
  methods: {
    goTo: function (row) {
      this.$router.push({path: `${row}`})
    },
    goToAuth() {
      this.$store.state.step = 1
      this.$store.commit('toggleAuth')
    },
    goToSignIn() {
      this.$router.push({
        path: '/login',
        query: { ...this.$route.query }
      })
    },
    async signOut() {
      await this.axios.delete('/logout', {
        headers: {
          'Authorization': this.token.value
        }
      });
      this.user.remove();
      this.token.remove();
      this.$root.currentUser = null
      if (this.$route.path !== '/') {
        await this.$router.push({path: '/'})
      }
      window.location.reload();
    }
  }
}
</script>

<style scope>
.user-button-wrapper {
  position: relative;
  transition: transform 0.3s ease;
}

.user-info {
  position: relative;
}

.user-info .caption {
  font-size: 0.75rem;
  line-height: 1.2;
  color: var(--v-textSecondary-base);
  margin-bottom: 0 !important;
}

.user-info .subtitle-2 {
  font-size: 0.875rem;
  line-height: 1.2;
  color: var(--v-textPrimary-base);
}

.user-avatar-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.user-avatar {
  /* background: linear-gradient(135deg, #4dd453, #58cc02) !important; */
  color: #16ad15;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, sans-serif !important;
  border: 1px solid rgb(222, 222, 222);
  transition: all 0.3s ease;
}

.avatar-hover {
  transform: scale(1.05);
}

.user-menu-content {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1) !important;
}

.user-menu-card {
  border-radius: 16px;
  overflow: hidden;
  background: var(--v-background-base);
  border: 1px solid rgba(130, 177, 255, 0.1);
}

.user-menu-list {
  background: transparent;
}

.menu-item {
  border-radius: 8px;
  margin: 0 8px;
  transition: all 0.3s ease;
}

.menu-item:hover {
  background: rgba(88, 204, 2, 0.08) !important;
}

.menu-item .v-list-item__title {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--v-textPrimary-base);
}

.menu-item .v-icon {
  color: var(--v-textSecondary-base);
  font-size: 20px;
}

/* Dark Theme Adjustments */
.theme--dark .user-menu-card {
  background: #1E1E1E;
  border-color: rgba(130, 177, 255, 0.05);
}

.theme--dark .user-menu-content {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3) !important;
}

.theme--dark .menu-item:hover {
  background: rgba(88, 204, 2, 0.15) !important;
}

/* Responsive Adjustments */
@media (max-width: 959px) {
  .user-info {
    display: none !important;
  }
}

@media (max-width: 599px) {
  .user-menu-card {
    width: 100%;
  }
}
</style>
